module.exports = {
      id: "pinterest-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#pinterest",
      toString: function () {
        return this.url;
      }
    }